import React from 'react';
import { BsFileEarmarkPlayFill } from "react-icons/bs";
import { Tabs } from 'antd';
import { DollarOutlined, LineChartOutlined, TrophyOutlined } from '@ant-design/icons';
import ProfitAnalysis from '../components/analytics/ProfitAnalysis';

function Analisis() {
    const items = [
        {
            key: '1',
            label: (
                <span>
                    <DollarOutlined />
                    Análisis de Rentabilidad
                </span>
            ),
            children: <ProfitAnalysis />
        },
        {
            key: '2',
            label: (
                <span>
                    <LineChartOutlined />
                    Tendencias (Próximamente)
                </span>
            ),
            children: (
                <div style={{ padding: 50, textAlign: 'center' }}>
                    <p>Análisis de tendencias de ventas y rentabilidad en desarrollo...</p>
                </div>
            ),
            disabled: true
        },
        {
            key: '3',
            label: (
                <span>
                    <TrophyOutlined />
                    Productos Top (Próximamente)
                </span>
            ),
            children: (
                <div style={{ padding: 50, textAlign: 'center' }}>
                    <p>Análisis de productos más rentables en desarrollo...</p>
                </div>
            ),
            disabled: true
        }
    ];

    return (
        <div className="editor-position" style={{ position: 'sticky', top: '10px', zIndex: 10 }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
                <BsFileEarmarkPlayFill size={42} style={{ color: 'black', marginRight: '0.75rem' }} />
                <h2>CUADROS DE ANÁLISIS DE NEGOCIO</h2>
            </div>

            <div
                className='div-signage-v3'
                style={{
                    padding: 20,
                    minHeight: '70vh',
                    width: '85vw',
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    overflowY: 'auto'
                }}
            >
                <Tabs 
                    defaultActiveKey="1" 
                    items={items}
                    size="large"
                    type="card"
                />
            </div>
        </div>
    );
}

export default Analisis;
